<div class="job-offer">
  <h2>جایگاه خود را انتخاب کنید</h2>
  <p>
    ایپام همواره به دنبال کشف استعداد و جذب نیروی خلاق و نوآور است. ما در ایپام با استقبال از چالش‌ها به دنبال نوآوری و پیشرفت در جهت رفع آن با
    استفاده از ظرفیت فناوری‌های روزآمد هستیم. مهم نیست از کجا آمده‌اید یا کجا تحصیل کرده‌اید، اگر کار خارق‌العاده‌ای انجام داده‌اید، به خانواده ایپام
    بپیوندید تا برای بهبود زندگی مردم تلاش کنیم.
  </p>

  <div class="offers-container">
    <div class="item">
      <img src="assets/backend-offer.png" />
      <main>
        <div class="title">
          <h3>استخدام برنامه‌نویس ارشد angular</h3>
          <div class="time-location">
            <span>
              <i [inlineSVG]="'assets/icons/clock.svg'"></i>
              تمام وقت
            </span>
            <span>
              <i [inlineSVG]="'assets/icons/placeholder-b.svg'"></i>
              تهران
            </span>
          </div>
        </div>
        <div class="content">
          <p>توسعه‌دهنده ارشد Front-End با مشخصات زیر جهت همکاری در تیم توسعه فرانت‌اند شرکت استخدام می‌گردد</p>
          <p>مهارتهای فنی</p>
          <p>
            <br />تسلط به Angular <br />تسلط به HTML5 <br />تسلط به CSS3 و Processors هایی مانند LESS یا SASS <br />تسلط کافی به متدولوژی‌های مدیریت
            State مانند NgRx <br />تسلط به Responsive Design <br />تسلط به کانسپت Functional Programming <br />آشنایی و تجربه کار با مفهوم SSR و
            ابزارهای مرتبط از قبیل AngularSSR <br />آشنایی با کانسپت Micro-Front-End Architecture <br />آشنایی یا تجربه کار با PWA و ابزارهای مرتبط
            (Service-Worker , manifest, etc) <br />تسلط به Git <br />تجربه بکارگیری GraphQL <br />آشنایی کافی با دانش الگوریتم‌ها، ساختار داده و
            آنالیز پیچیدگی <br />آشنایی با Angular CDK <br />مهارت‌های حرفه‌ای

            <br />دارای تجربه کار تیمی <br />منظم و متعهد <br />دارای تعامل مثبت و سازنده با سایر همکاران <br />علاقه‌مند به یادگیری و پیشرفت
          </p>
        </div>
      </main>
    </div>
    <div class="item">
      <img src="assets/backend-offer.png" />
      <main>
        <div class="title">
          <h3>توسعه‌دهنده پایتون</h3>
          <div class="time-location">
            <span>
              <i [inlineSVG]="'assets/icons/clock.svg'"></i>
              تمام وقت
            </span>
            <span>
              <i [inlineSVG]="'assets/icons/placeholder-b.svg'"></i>
              تهران
            </span>
          </div>
        </div>
        <div class="content">
          <p>گردش‌پی جهت تکمیل تیم توسعه اپلیکیشن خود چند نفر توسعه‌دهنده پایتون با مشخصات زیر استخدام می‌نماید.</p>
          <p>توانمندی‌های مورد نیاز</p>
          <p>
            <br />
            تجربه کافی با سیستم عامل لینوکس <br />مسلط بر اصول کد نویسی با زبان پایتون <br />مسلط بر فریمورک جنگو (ORM, Transactions, DRF,…)
            <br />مسلط بر یکی از دیتابیس‌های Rational مانند MySQL <br />مسلط بر یکی از دیتابیس‌های NoSQL مانند MongoDB <br />مسلط بر مدیریت کش همانند
            Redis, Memcached <br />آشنا به مفاهیم و کاربرد تکنیک‌ها (RESTful, JWT, OAUTH, … ) <br />اصول توسعه و نگهداری کد مانند DRY, SOLID
            <br />دانش و توانایی کافی در حل مسائل به صورت بهینه <br />توانایی همکاری و ارتباط با سایر اعضای تیم <br />مسئولیت پذیر و پویا

            <br />ویژگی‌های زیر مزیت محسوب می‌شوند

            <br />سابقه کار در حوزه سوپراپلیکیشن‌ها و یا پرداخت <br />آشنایی با فلسک و FastAPI <br />آشنا به زبان‌های برنامه‌نویسی دیگر <br />دانش
            کافی در طراحی دیتابیس <br />آشنا به Message Brokerها <br />آشنا به مباحث امنیتی وب‌سرویس‌ها
          </p>
        </div>
      </main>
    </div>
    <div class="item">
      <img src="assets/backend-offer.png" />
      <main>
        <div class="title">
          <h3>توسعه‌دهنده ارشد Flutter</h3>
          <div class="time-location">
            <span>
              <i [inlineSVG]="'assets/icons/clock.svg'"></i>
              تمام وقت
            </span>
            <span>
              <i [inlineSVG]="'assets/icons/placeholder-b.svg'"></i>
              تهران
            </span>
          </div>
        </div>
        <div class="content">
          <p>گردش‌پی جهت تکمیل تیم توسعه اپلیکیشن خود، چند توسعه‌دهنده ارشد فلاتر با مشخصات زیر استخدام می‌نماید.</p>
          <p>شروط الزامی</p>
          <p>
            <br />جربه ی کار با حداقل یکی از زبان‌های نیتیو مرتبط با موبایل (Kotlin, Java, Objective-C, Swift) <br />مسلط بر برنامه‌نویسی فلاتر
            <br />داشتن حداقل ۱ پروژه به اتمام رسیده با فلاتر <br />تسلط نسبی به درک مفهوم زبان انگلیسی <br />توانایی تعامل و ارتباط با تیم‌ها و افراد
            مختلف <br />توانایی در مستندسازی پروژه و ارائه گزارش‌های لازم <br />توانایی کار در محیط داینامیک <br />توانمندی‌های مورد نیاز

            <br />مسلط به Flutter و زبان برنامه نویسی Dart <br />تجربه کار با طراحی واسط کاربری بر مبنای Material Design <br />تسلط به مفاهیم
            responsive در فلاتر <br />تسلط در Push Notification, Firebase <br />تسلط کامل به مدل‌های ارتباطی client/server مثل REST و GraphQL
            <br />توانایی کامل در پیاده‌سازی رابط کاربری بر اساس موکاپ طراحی شده
          </p>
        </div>
      </main>
    </div>
    <p>
      در صورت تمایل به همکاری می‌توانید رزومه و عنوان فرصت شغلی مورد نظر خود را به ایمیل
      <a href="mailto:HR@gardeshpay.com">HR@gardeshpay.com</a> ارسال نمایید.
    </p>
  </div>
</div>
